// PO Creation nav badge (owner 2026-10-25): the $ amount that should be reordered now, from
// GET /api/po-creation/reorder-badge (the page's default view, recomputed every 30 min and after skips).

/** Compact $ for the badge, or null when there is nothing to show. "+" = some rows have no known cost. */
export function badgeLabel(b) {
    if (!b || b.pending || !(b.count > 0)) return null;
    const d = Number(b.dollars) || 0;
    const plus = b.unknownCostCount > 0 && d === 0 ? '+' : '';
    if (d >= 1e6) return `$${(d / 1e6).toFixed(1)}M`;
    if (d >= 1e3) return `$${(d / 1e3).toFixed(1)}k`;
    return `$${Math.round(d)}${plus}`;
}

/** Hover text: count, exact $, unknown-cost rows, when computed. */
export function badgeTitle(b) {
    if (!b || b.pending) return '';
    const dollars = `$${Math.round(Number(b.dollars) || 0).toLocaleString('en-US')}`;
    const unknown = b.unknownCostCount > 0 ? ` (+${b.unknownCostCount} without a known cost)` : '';
    const when = b.computedAt ? ` — as of ${new Date(b.computedAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}` : '';
    return `${b.count} products to order now · ${dollars}${unknown}${when}`;
}
